import { createAction } from '@reduxjs/toolkit';
import { MANAGE_VIEW_ACTIONS } from './viewActionConstants';
import {
  IMessageBarErrorState,
  IMessageBarInfoState,
  IMessageBarSuccessState,
  IMessageBarErrorItem,
} from '../../interfaces/MessageBar';

export const updateMessageBarSuccessState = createAction(
  MANAGE_VIEW_ACTIONS.UPDATE_MESSAGE_BAR_SUCCESS_STATE,
  function prepare(payload: IMessageBarSuccessState) {
    return {
      payload,
    };
  }
);

export const updateMessageBarErrorState = createAction(
  MANAGE_VIEW_ACTIONS.UPDATE_MESSAGE_BAR_ERROR_STATE,
  function prepare(payload: IMessageBarErrorState) {
    return {
      payload,
    };
  }
);

export const updateMessageBarInfoState = createAction(
  MANAGE_VIEW_ACTIONS.UPDATE_MESSAGE_BAR_INFO_STATE,
  function prepare(payload: IMessageBarInfoState) {
    return {
      payload,
    };
  }
);

// New action for multiple error messages
export const updateMessageBarMultipleErrorsState = createAction(
  'messageBar/updateMultipleErrors',
  function prepare(payload: { errors: IMessageBarErrorItem[]; isShow: boolean }) {
    return {
      payload,
    };
  }
);

// Action to add a single error to the existing errors
export const addMessageBarError = createAction(
  'messageBar/addError',
  function prepare(payload: IMessageBarErrorItem) {
    return {
      payload,
    };
  }
);

// Action to remove a specific error by id
export const removeMessageBarError = createAction(
  'messageBar/removeError',
  function prepare(payload: { id: string }) {
    return {
      payload,
    };
  }
);

// Action to clear all errors
export const clearAllMessageBarErrors = createAction('messageBar/clearAllErrors');

//Disaply invalid user : show
export const showWarningMessageBar = createAction(
  'messageBar/showWarningMessageBar',
  function prepare(payload: { message: Array<{formFieldLabel : string}>; timeOut?: number  | undefined }) {
    return {
      payload,
    };
  }
);

//Disaply invalid user : hine
export const hideWarningMessageBar = createAction(
  'messageBar/hideWarningMessageBar',
  function prepare(payload) {
    return {
      payload,
    };
  }
);

// Sensitive info validation: add a field with sensitive info error
export const addSensitiveInfoField = createAction(
  'messageBar/addSensitiveInfoField',
  function prepare(payload: { fieldName: string }) {
    return { payload };
  }
);

// Sensitive info validation: remove a field's sensitive info error
export const removeSensitiveInfoField = createAction(
  'messageBar/removeSensitiveInfoField',
  function prepare(payload: { fieldName: string }) {
    return { payload };
  }
);

// Sensitive info validation: clear all sensitive info field errors
export const clearAllSensitiveInfoFields = createAction('messageBar/clearAllSensitiveInfoFields');

export const editOnClick = createAction(
  MANAGE_VIEW_ACTIONS.EDIT_ON_CLICK,
  function prepare(payload: boolean) {
    return {
      payload,
    };
  }
);

export const onViewChange = createAction(
  MANAGE_VIEW_ACTIONS.VIEW_ON_CHANGE,
  function prepare(payload: boolean) {
    return {
      payload,
    };
  }
);

export const manageViewSetSkipIndex = createAction(
  MANAGE_VIEW_ACTIONS.SET_SKIP_INDEX,
  function prepare(payload: number) {
    return {
      payload,
    };
  }
);

export const updateFetchShouldCall = createAction(
  MANAGE_VIEW_ACTIONS.UPDATE_FETCH_SHOULD_CALL,
  function prepare(payload: boolean) {
    return {
      payload,
    };
  }
);

export const clearPreviewGridItems = createAction(MANAGE_VIEW_ACTIONS.CLEAR_PREVIEW_GRID_ITEMS);
